import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";

/**
 * Created by Jerker Nord on 2019-07-03.
 */

export class ThorFSThorNearWinReelStopController extends ReelStopPresentationController{

    constructor(index:number) {
        super(index, "ThorFSThorNearWinReelStopController");
    }

    public onReelBounce(data:IReelStoppedData):void {
        if (data.reelId == 4){
            ThorGameModuleConfig.thorFSThorNearWinView.disableNearWin();
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }
}